import { TranslateLanguages } from '../../store/workspace/types';

/** A language an exam can be taken in, keyed by the id the exam endpoints expect. */
export interface ExamLanguage {
    id: string;
    title: string;
};

/** Language an exam is taken in when the job offers no other. */
export const DEFAULT_EXAM_LANGUAGE = 'EN';

/** Turns the languages a job offers into dropdown items. */
export const toExamLanguages = (languages?: TranslateLanguages): ExamLanguage[] =>
    Object.entries(languages || {}).map(([id, { name }]) => ({ id, title: name }));

/** The default language when the job offers it, otherwise the first one it does. */
export const initialExamLanguage = (languages: ExamLanguage[]): string =>
    languages.some(i => i.id === DEFAULT_EXAM_LANGUAGE)
        ? DEFAULT_EXAM_LANGUAGE
        : languages[0]?.id || DEFAULT_EXAM_LANGUAGE;

/** Only a job offering something beyond the default leaves the applicant a choice. */
export const hasLanguageChoice = (languages: ExamLanguage[]): boolean =>
    languages.some(i => i.id !== DEFAULT_EXAM_LANGUAGE);
